import { filter, pipe } from "callbag-basics";
import subscribe from "callbag-subscribe";
import { useCallback, useEffect } from "react";

import { actions$ } from "store/action-stream";
import { IAction } from "store/helper";
import { IPartialInvitePayload, WelcomeTutorialViewActionsNames } from "store/views/welcome-tutorial";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onPartialInvite = (fn: (action: IPartialInvitePayload) => void) =>
  pipe(
    actions$,
    filter((action: IAction) => action.type === WelcomeTutorialViewActionsNames.INVITE_AGENTS_PARTIAL_SUCCESS),
    // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'IAction... Remove this comment to see the full error message
    subscribe((action: IAction) => fn(action.payload as IPartialInvitePayload))
  );

export const usePartialInvite = (callback: (action: IPartialInvitePayload) => void): void => {
  const cb = useCallback(callback, []);

  useEffect(() => {
    const unsubscribe = onPartialInvite(cb);
    return unsubscribe;
  }, []);
};
